// extracted by mini-css-extract-plugin
export default {"cardContainer":"CardListContainer_cardContainer__9iDfQ","virtualGridContainer":"CardListContainer_virtualGridContainer__kQZGj"};